import { darkMode } from "./common/dark.js";
import $ from "./util/dom.js";
import { openModal, closeModal } from "./util/modal.js";
import { puzzleId } from "./common/daily.js";

// these are numbers to keep data exports at a manageable size
export const ADD_CORRECT = 0;
export const REMOVE_CORRECT = 1;
export const ADD_WRONG = 2;
export const REMOVE_WRONG = 3;
export const CHEAT = 4;

export function updateStory(story) {
	const result = storyToEmoji(story);
	$.resultSpan.innerHTML = '';
	$.resultSpan.appendChild(document.createTextNode(result));
	$.resultSpan2.innerHTML = '';
	$.resultSpan2.appendChild(document.createTextNode(result));
	const title = `#CellTower ${puzzleId}`;
	const url = `https://www.andrewt.net/puzzles/cell-tower/?p=${puzzleId}`;
	const tweet = `${title}\n\n${result}\n\n${url}`;
	$.tweetResult.setAttribute('href', `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweet)}`);
	$.deviceShareResult.setAttribute('data-title', 'title');
	$.deviceShareResult.setAttribute('data-text', `${title}\n\n${result}`);
	$.deviceShareResult.setAttribute('data-url', url);
	$.copyResult.setAttribute('data-content', tweet);
}

if (!navigator.clipboard) $.copyResult.classList.add('hidden');
$.copyResult.addEventListener('click', async () => {
	// This returns a promise but we don't need to care about it.
	try {
		await navigator.clipboard.writeText($.copyResult.getAttribute('data-content'));
		$.copyResult.innerText = 'Done!';
		$.copyResult.disabled = true;
	} catch (e) {
		console.error('Error copying to clipboard.');
		console.error(e);
		alert('Error copying to clipboard:\n\n' + e.message);
	}
});

if (!navigator.share) $.deviceShareResult.classList.add('hidden');
$.deviceShareResult.addEventListener('click', () => {
	// This also returns a promise but we don't need to care about it.
	navigator.share({
		title: $.deviceShareResult.getAttribute('data-title'),
		text: $.deviceShareResult.getAttribute('data-text'),
		url: $.deviceShareResult.getAttribute('data-url')
	});
});
$.shareResultButton.addEventListener('click', () => {
	openModal('share-result');
	$.copyResult.innerText = 'Copy to clipboard';
	$.copyResult.disabled = false;
});
$.closeShareResult.addEventListener('click', () => closeModal());

function storyToEmoji(story) {
	let width = 0, height = 0;
	let x = 0, y = 1;
	for (const i of story) {
		switch (i) {
			case ADD_CORRECT: ++x; break;
			case REMOVE_CORRECT: --x; break;
			case ADD_WRONG: ++y; break;
			case REMOVE_WRONG: --y; break;
			case CHEAT: y = 1; break;
		}
		if (x > width) width = x;
		if (y > height) height = y;
	}
	const grid = [];
	for (let y = 0; y < height; ++y) {
		grid[y] = [];
		for (let x = 0; x < width; ++x)
			grid[y][x] = '⬜';
	}
	x = 0;
	y = height - 1;
	for (const i of story) switch (i) {
		case ADD_CORRECT: setGrid(x, y, '➡️'); ++x; break;
		case REMOVE_CORRECT: setGrid(x, y, '⬅️'); --x; break;
		case ADD_WRONG: setGrid(x, y, '⬆️'); --y; break;
		case REMOVE_WRONG: setGrid(x, y, '⬇️'); ++y; break;
		case CHEAT: setGrid(x, y, '🔮'); y = height - 1; break;
	}
	function setGrid(x, y, c) {
		if (grid[y][x] == '⬜' || c == '🔮') grid[y][x] = c;
		else if (grid[y][x] != '🔮') grid[y][x] = '⏹️';
	}
	// TODO: maybe shrink horizontally by collapsing several "just go across" columns into one with ⏩
	// shrink if there are 4 in a row to ➡️⏩➡️
	// don't shrink grid to less than 7 total width
	const output = grid.map(row => row.join('')).join('\n');
	if (darkMode.active) return output.replace(/⬜/g, '⬛');
	return output;
}
